import React from 'react';
import { motion } from 'framer-motion';
import { trainingLogs, pets } from '../data/mockData';
import SafeIcon from '../common/SafeIcon';

export default function Training() {
  return (
    <div className="space-y-8">
      <header className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-3xl font-bold text-slate-800 tracking-tight">Training Uplink</h1>
          <p className="text-slate-500 mt-1">Monitor skill acquisition and behavioral milestones.</p>
        </div>
        <button className="bg-[#FF7F50] hover:bg-[#ff6b35] text-white px-6 py-3 rounded-2xl font-bold transition-all shadow-lg shadow-orange-200 flex items-center gap-2">
          <SafeIcon icon="FiPlus" />
          <span>New Drill</span>
        </button>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {trainingLogs.map((log, idx) => {
          const pet = pets.find(p => p.id === log.petId);
          return (
            <motion.div
              key={log.id}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.1 }}
              className="bg-white/80 backdrop-blur-xl p-6 rounded-3xl shadow-sm border border-white"
            >
              <div className="flex items-center gap-3 mb-6">
                <img src={pet?.image} className="w-12 h-12 rounded-full object-cover border-2 border-[#F5EFE6]" />
                <div>
                  <h3 className="font-bold text-slate-800">{log.skill}</h3>
                  <p className="text-xs text-slate-400 uppercase font-black tracking-widest">{pet?.name}</p>
                </div>
              </div>

              <div className="space-y-4">
                <div className="flex justify-between items-end">
                  <span className="text-xs font-bold text-slate-500 uppercase">Proficiency</span>
                  <span className="text-lg font-black text-[#0047AB]">{log.progress}%</span>
                </div>
                <div className="h-3 w-full bg-slate-100 rounded-full overflow-hidden">
                  <motion.div 
                    initial={{ width: 0 }}
                    animate={{ width: `${log.progress}%` }}
                    className="h-full bg-gradient-to-r from-[#0047AB] to-[#4070F4]"
                  />
                </div>
                <div className="flex justify-between items-center text-[10px] font-bold pt-2">
                  <span className="px-2 py-1 bg-blue-50 text-[#0047AB] rounded uppercase">{log.level}</span>
                  <span className="text-slate-400 uppercase tracking-widest">{log.status}</span>
                </div>
              </div>
            </motion.div>
          );
        })}
      </div>
    </div>
  );
}